import { render } from "./TaskOrderManagementSystemApp.vue?vue&type=template&id=9fb63054&scoped=true&ts=true"
import script from "./TaskOrderManagementSystemApp.vue?vue&type=script&lang=ts"
export * from "./TaskOrderManagementSystemApp.vue?vue&type=script&lang=ts"

import "./TaskOrderManagementSystemApp.vue?vue&type=style&index=0&id=9fb63054&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb63054"]])

export default __exports__